import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { SlideLayout } from '@gripp/shared-ui';
import { AssetComponent } from './assetComponent';
import { Assets as AssetsOld } from './assets-old';
import { AssetsFilters } from './assetsFilters';

export const Assets = () => {
  const isCropCircleEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  if (isCropCircleEnabled) {
    return <AssetsBase />;
  }

  return <AssetsOld />;
}

const AssetsBase = () => {
  return (
    <SlideLayout
      leftColumn={{
        title: 'assets.menu.title',
        mainComponent: <AssetComponent />,
        headerComponent: <AssetsFilters />
      }}
    />
  );
}

